const links = [
  {
    label: "Javascript",
    component: "Javascript",
  },
  {
    label: "ReactJs",
    component: "React",
  },
  {
    label: "React native",
    component: "React",
  },
  {
    label: "Vue",
    component: "Vuejs",
  },
  {
    label: "Nodejs",
    component: "Nodejs",
  },
  {
    label: "Html",
    component: "Html",
  },
  {
    label: "Css",
    component: "Css",
  },
  {
    label: "Postgresql",
    component: "Postgresql",
  },
  {
    label: "Mongodb",
    component: "Mongodb",
  },
  {
    label: "Git",
    component: "Git",
  },
  // {
  //   label: "Java",
  //   component: "Java",
  // },
]

export default links
